export default __webpack_public_path__ + "assets/select.c35160aa.svg";